
import Vue from 'vue';
import { useStore as useProductStore } from '@/stores/product';
import { mapState } from 'pinia';
import { mm2px } from '@midocean/webapps-shared-domain';
export default Vue.extend({
  name: 'Ruler',
  props: {
    zoomLevel: {
      type: Number,
      required: false,
      default: 1,
    },
    isVerticalRulerDisplayed: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHorizontalRulerDisplayed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      minMillimeterValue: 1,
    };
  },
  computed: {
    ...mapState(useProductStore, ['selectedPrintPosition']),
    numberOfSpaces(): number {
      return this.lowerTicksSpace < 10 || this.lowerTicksSpace > 25 ? 10 : 5;
    },
    lowerTicksSpace(): number {
      return this.getMinLowerTicksSpace();
    },
    higherTicksSpace(): number {
      return this.numberOfSpaces * this.lowerTicksSpace;
    },
    points(): number[] {
      let millimeters: number[] = [];
      let counter = 1;
      while (counter * this.lowerTicksSpace < 770) {
        millimeters.push(
          counter * this.numberOfSpaces * this.minMillimeterValue
        );
        counter++;
      }
      return millimeters;
    },
  },
  methods: {
    getMinLowerTicksSpace(): number {
      const minLowerTicksSpace =
        mm2px(
          this.minMillimeterValue,
          this.selectedPrintPosition.originalImageWebDpi
        ) * this.zoomLevel;
      if (minLowerTicksSpace < 5) {
        this.minMillimeterValue = 5;
        return (
          mm2px(
            this.minMillimeterValue,
            this.selectedPrintPosition.originalImageWebDpi
          ) * this.zoomLevel
        );
      }
      if (minLowerTicksSpace > 25) {
        this.minMillimeterValue = 1;
        return (
          mm2px(
            this.minMillimeterValue,
            this.selectedPrintPosition.originalImageWebDpi
          ) * this.zoomLevel
        );
      }
      return minLowerTicksSpace;
    },
  },
});
